import { defineStore } from 'pinia'

interface State {
  openedModalIds: { id: string, close: () => void }[],
}

export const useModalStore = defineStore('Modal', {
  state: (): State => ({
    openedModalIds: [],
  }),
  actions: {
    push (id: string, close: () => void) {
      this.openedModalIds.push({ id, close })
    },
    pop () {
      this.openedModalIds.pop()?.close()
    },
    remove (id: string) {
      const index = this.openedModalIds.findIndex(modal => modal.id === id)
      if (index !== -1) {
        this.openedModalIds.splice(index, 1)
      }
    },
  },
})
